import 'Variables';
import { InsertSettings } from 'BobjollNotifications';
import { modal } from 'BobjollModal';
import { Position } from 'BobjollNotifications';
import Notification from 'BobjollNotifications';
import { Auth } from '../auth';

export default class User {
    static async isLogged(showModal: boolean = true) {
        // return new Promise(async resolve => {
        //     let status = gr.isLogged();

        //     if (!status && showModal) {
        //         if ('undefined' !== typeof gr) {
        //             await gr.login();

        //             status = gr.isLogged();
        //         }
        //     }

        //     resolve(status);
        // });

        let status = User.isLibraryLoaded() && gr.isLogged();

        if (!status && showModal) {
            window.location.href = `https://profile.freepik.com/login?cb_url=${window.location.href}`;
        }

        return true;
    }

    static isFreepik() {
        return (User.isLibraryLoaded() && (gr.user && gr.user.email || '').match(/\@freepik.com/) ? true : false);
    }

    static isPremium() {
        return (User.isLibraryLoaded() && gr.isPremium()) || false;
    }

    static id() {
        return User.isLibraryLoaded() ? (gr.isLogged() && gr.user ? gr.user.id : 0) : 0;
    }

    static type() {
        return User.isLibraryLoaded() ? (gr.isLogged() ? (gr.isPremium() ? 'Premium' : 'Free') : 'Guest') : 'Guest';
    }

    static isLibraryLoaded() {
        return ('undefined' !== typeof gr);
    }

    static getData() {
        if (User.isLogged(false)) {
            return gr.user;
        }

        return null;
    }
}